class SkfEvent {
  private exp: any;
  private cs: any = null;
  private evs: string;
  private isParent = false;

  constructor(
    private elem: HTMLElement,
    private target: any,
    private type: string
  ) {
    const attr = this.elem.getAttribute(this.type);
    const arr = attr.match(/([^\s(]+)[\s(]+([^)]+)\)/);
    this.getParams(arr);
    this.bindEvent();
  }

  getParams(arr: string[]): void {
    const _this = this;
    if (/\$parent\./.test(arr[1])) {
      this.isParent = true;
      arr[0] = arr[0].replace("$parent.", "");
      arr[1] = arr[1].replace("$parent.", "");
    }
    this.elem[arr[1]] = function (...args) {
      _this.cs = args;
    };
    new Function("return this." + arr[0]).call(this.elem);
    this.exp = this.type.replace("skf-", "");
    this.evs = arr[1];
  }

  bindEvent(): void {
    const _this = this;
    this.elem[`on${this.exp}`] = function (ev) {
      if (_this.isParent) {
        _this.target.$parent[_this.evs](ev, ..._this.cs, () => {
          _this.target.updateView();
        });
      } else {
        _this.target.field[_this.evs](ev, ..._this.cs);
      }
      _this.target.updateView();
    };
  }
}

export { SkfEvent };
